import React from 'react';

const AnalyticsCard = ({ icon, title, value, subtitle, color }) => {
  return (
    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 hover:bg-white/15 transition-all duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className={`${color} p-3 rounded-xl`}>
          <div className="text-white">{icon}</div>
        </div>
      </div>
      <div className="space-y-1">
        <h3 className="text-white/80 text-sm font-medium">{title}</h3>
        <p className="text-white text-3xl font-bold">{value?.toLocaleString()}</p>
        <p className="text-white/60 text-xs">{subtitle}</p>
      </div>
    </div>
  );
};

export default AnalyticsCard;